import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from '../axios';
import {
    Container,
    DetailsBtns,
    DetailsHeading,
    H1,
    H3,
    HeadingLeft, MediumSpacing,
    ProfileTable,
    Table,
    Td,
    Th,
    Tr
} from "../../styles";

const StudentDetail = () => {
    const {id} = useParams();
    const [student, setStudent] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchStudentData = async () => {
        try {
            const response = await axios.get(`/student/${id}/`);
            setStudent(response.data);
            setLoading(false);
        } catch (error) {
            console.error("There was an error fetching the student data!", error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStudentData();
    }, [id]);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!student) {
        return <div>Student not found</div>;
    }

    return (
        <Container>
            <HeadingLeft>
                <H1>Student Detail</H1>
            </HeadingLeft>
            <MediumSpacing/>
            <ProfileTable>
                <tbody>
                <Tr>
                    <Td className="row_heading">ID</Td>
                    <Td className="row_heading">{student.student_id}</Td>
                </Tr>
                <Tr>
                    <Td className="row_heading">First Name</Td>
                    <Td className="row_heading">{student.first_name}</Td>
                </Tr>
                <Tr>
                    <Td className="row_heading">Last Name</Td>
                    <Td className="row_heading">{student.last_name}</Td>
                </Tr>
                <Tr>
                    <Td className="row_heading">Email</Td>
                    <Td className="row_heading">{student.email}</Td>
                </Tr>
                <Tr>
                    <Td className="row_heading">DOB</Td>
                    <Td className="row_heading">{student.dob}</Td>
                </Tr>
                </tbody>
            </ProfileTable>
            {student.classes_enrolled && student.classes_enrolled.length > 0 ? (
                <>
                    <MediumSpacing/>
                    <HeadingLeft>
                        <H3>Classes Enrolled</H3>
                    </HeadingLeft>
                    <MediumSpacing/>
                    <Table>
                        <thead>
                        <Tr>
                            <Th>Class</Th>
                            <Th>Class Number</Th>

                            <DetailsHeading>Grade</DetailsHeading>
                        </Tr>
                        </thead>
                        <tbody>
                        {student.classes_enrolled.map((classItem, index) => (
                            <Tr key={index}>
                                <Td>{classItem.course_details.name}</Td>
                                <Td>{classItem.number}</Td>

                                <DetailsBtns>{classItem.grade}</DetailsBtns>
                            </Tr>
                        ))}
                        </tbody>
                    </Table>
                </>
            ) : (
                <p>No classes enrolled</p>
            )}
        </Container>
    );
};

export default StudentDetail;
